export const environment = {
  APP_ORIGIN: 'https://app-dev.kyudo.io',
  INSIGHT_DASHBOARD_API_URL:
    'https://dev-api.kyudo.io/insights-dashboard/web/v1', // INSIGHT TAP DATA API
  INSIGHT_API_URL: 'https://dev-api.kyudo.io/insights-api/web/v2',
  CMS_API_URL: 'https://dev-api.kyudo.io/insights-cms-service/web/v1', // INSIGHT PWA CMS
  PWA_API_URL: 'https://dev-pwa-backend.kyudo.io', // PWA APIs (for reordering, quiz responses, etc)
  STRIPE_TEST_PK:
    'pk_test_51Id8csDMy2mdqnA6otgrch5lJ2GZsO0xYG16LP2TA8DDsTvDvptgk26gAuzh3L4TWm0NKctu1YCel5n9r4ace1L4005JPmYQgG',
  STRIPE_PK:
    'pk_test_51Id8csDMy2mdqnA6otgrch5lJ2GZsO0xYG16LP2TA8DDsTvDvptgk26gAuzh3L4TWm0NKctu1YCel5n9r4ace1L4005JPmYQgG',
  GA_TRACKING_CODE: 'G-443N0GS8Q6',
  MIGRATED_APP_TYPES: [
    'educational',
    'quiz',
    'survey',
    'instructions',
    'product-authentication',
    'spotlight',
    'form',
    'reordering',
    'golden-ticket',
    'pq201s-authentication',
  ],
  COOKIE_CONSENT: false,
  DEMO_STRIPE_ACCOUNT: 'acct_1JPN7JLtjTAhEf1V',
  SENTRY_DSN: '',
  includeBuilder: true,
  production: false,
  TAP_URL: 'https://dtp.kyudo.io',
  POSTHOG_KEY: 'phc_Jf77cZLrAli2CS6PsELSrKHh2Ql4JO9xXD0piJgq7tm',
  POSTHOG_HOST: 'https://us.i.posthog.com',
};
